// extracted by mini-css-extract-plugin
export var footerContainer = "Footer-module--footerContainer--Y00s9";
export var footerInfo = "Footer-module--footerInfo--2kDHj";
export var footerLink = "Footer-module--footerLink--MLZrW";
export var footerLogo = "Footer-module--footerLogo--rgzaq";
export var footerMenu = "Footer-module--footerMenu---X5YK";
export var footerWrapper = "Footer-module--footerWrapper--r5X31";
export var infoP = "Footer-module--infoP--qidh3";